import { FC, useMemo } from 'react'
import { Loader } from 'src/modules/core/components'
import { useUserPreferences } from 'src/modules/preferences/hooks/use-user-preferences'
import { SettingsProfileInfo } from 'src/modules/user/components'
import { useProfile } from 'src/modules/user/hooks/use-profile'
import classes from './settings-my-details-tab.module.scss'

export const SettingsMyDetailsTab: FC = () => {
  const profile = useProfile()
  const preferences = useUserPreferences()

  const isLoading = useMemo(() => profile.isLoading, [profile.isLoading])

  if (isLoading) return <Loader isLoading={isLoading} />

  return (
    <div className={classes.settingsWrapper}>
      <div className={classes.settingsWrapperChild}>
        {profile.data && <SettingsProfileInfo profileInfo={profile.data} preferences={preferences.data} />}
      </div>
    </div>
  )
}
